// Labelled checkbox with a `--tap-min` (44 px) hit area even though the visual box stays small
// (DESIGN-VISUAL.md §6.8). Used wherever a person confirms understanding or grants a consent —
// never rendered without its label text next to it.
import type { InputHTMLAttributes, ReactNode } from 'react';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  id: string;
  label: ReactNode;
}

export function Checkbox({ id, label, className = '', ...rest }: CheckboxProps) {
  return (
    <label htmlFor={id} className="flex min-h-tap-min cursor-pointer items-start gap-s2">
      <input
        id={id}
        type="checkbox"
        className={['mt-s1 h-s5 w-s5 rounded-control border border-ink-soft', className]
          .filter(Boolean)
          .join(' ')}
        {...rest}
      />
      <span className="text-body text-ink">{label}</span>
    </label>
  );
}
